
import { PuttSituation } from "@/types/golf";
import { longPutts } from "./putting/longPutts";
import { mediumPutts } from "./putting/mediumPutts";
import { slopePutts } from "./putting/slopePutts";
import { offensivePutts } from "./putting/offensivePutts";
import { shortPutts1m } from "./putting/shortPutts1m";
import { shortPutts2m } from "./putting/shortPutts2m";

// Gathering all putting situations in one place
export const puttingSituations: PuttSituation[] = [
  longPutts,
  mediumPutts,
  slopePutts,
  offensivePutts,
  shortPutts1m,
  shortPutts2m,
];
